import React, { useEffect } from "react";
import { createPortal } from "react-dom";

// Import your existing pages:
import Agb from "../footer/agb.jsx";
import Datenschutz from "../footer/datenschutz.jsx";
import Impressum from "../footer/impressum.jsx";
import Widerruf from "../footer/widerruf.jsx";

const MAP = {
  agb: { title: "Terms & Conditions (AGB)", Comp: Agb },
  datenschutz: { title: "Privacy Policy (Datenschutzerklärung)", Comp: Datenschutz },
  impressum: { title: "Impressum", Comp: Impressum },
  widerruf: { title: "Right of Withdrawal / Cancellation", Comp: Widerruf },
};

export default function LegalModal({ slug, onClose }) {
  const entry = slug ? MAP[slug] : null;

  // Create portal mount
  let mount = document.getElementById("legal-portal");
  if (!mount) {
    mount = document.createElement("div");
    mount.id = "legal-portal";
    document.body.appendChild(mount);
  }

  // ESC key + body scroll lock
  useEffect(() => {
    if (!slug) return;
    const onEsc = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onEsc);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onEsc);
      document.body.style.overflow = prev;
    };
  }, [slug, onClose]);

  if (!entry) return null;
  const { title, Comp } = entry;

  const content = (
    <div className="fixed inset-0 z-[1000]">
      {/* Backdrop */}
      <button
        aria-label="Close"
        onClick={onClose}
        className="absolute inset-0 bg-black/50"
      />
      {/* Panel */}
      <div className="absolute inset-0 flex items-start justify-center p-4 sm:p-6">
        <div className="relative w-full max-w-4xl rounded-2xl bg-white shadow-xl ring-1 ring-black/5 overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
            <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
            <button
              onClick={onClose}
              className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 hover:bg-gray-50"
              aria-label="Close modal"
            >
              <svg className="h-4 w-4 text-gray-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
              </svg>
            </button>
          </div>
          {/* Body (scrollable) */}
          <div className="max-h-[75vh] overflow-y-auto px-5 py-6">
            {/* Render your page component inside */}
            <Comp />
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(content, mount);
}
